@if (toolCalls().length) {
  <div class="mb-2" data-e2e="ai-thinking-card">
    @if (settled()) {
      <button
        type="button"
        class="inline-flex flex-row items-center gap-1.5 h-[26px] px-2.5 rounded-full bg-surface-0 dark:bg-surface-800 border border-solid border-surface-200 dark:border-surface-700 text-xs font-semibold text-surface-700 dark:text-surface-200 cursor-pointer"
        [attr.aria-expanded]="expanded()"
        [attr.aria-controls]="listId"
        (click)="toggle()"
        data-e2e="ai-thinking-toggle"
      >
        <div class="inline-flex flex-row items-center justify-center bg-green-600 rounded-full w-3.5 h-3.5 flex-none">
          <i class="mi2-check text-[7px] text-white"></i>
        </div>
        <span>{{ 'cl_chat.aiThinking' | translate }}</span>
        <i
          class="mi2-arrow-down text-[11px] transition-transform duration-200 ease-in-out"
          [ngClass]="{ 'rotate-180': expanded() }"
        ></i>
      </button>
    }
    @if (expanded()) {
      <div [id]="listId" class="flex flex-col gap-1.5" [ngClass]="{ 'mt-1.5': settled() }" data-e2e="ai-thinking-list">
        @for (toolCall of toolCalls(); track toolCall.toolCallId + '-' + $index) {
          <div class="flex items-center gap-2">
            @if (isRowSpinning(toolCall)) {
              <p-progress-spinner
                styleClass="w-4 h-4 flex-none"
                strokeWidth="8"
                animationDuration=".5s"
                fill="transparent"
                [attr.aria-label]="'cl_chat.aiThinking' | translate"
              ></p-progress-spinner>
            } @else {
              <div class="inline-flex flex-row items-center justify-center bg-green-600 rounded-full w-4 h-4 flex-none">
                <i class="mi2-check text-[7px] text-white"></i>
              </div>
            }
            <span class="text-xs text-surface-700 dark:text-surface-200" data-e2e="ai-thinking-row-label">
              {{ rowLabelKey(toolCall) | translate: rowLabelParams(toolCall) }}
            </span>
          </div>
        }
      </div>
    }
  </div>
}
